import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/about/AboutClient.tsx");
